import { QueryKey, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';

export function useBlobQuery(fileUrl: string, options?: UseQueryOptions<Blob>) {
  return useQuery(
    [fileUrl] as QueryKey,
    async () => {
      // For generic blobs (not from abacus) we don't want to use the default api since it'll take on the authorization
      // header which other endpoints may not accept.
      const response = await axios.get<Blob>(fileUrl, { responseType: 'blob' });
      return new Blob([response.data]);
    },
    {
      ...options,
      staleTime: options?.staleTime ?? MAX_STALE_TIME,
    }
  );
}
